module.exports = "/images/green-plus.svg?47fcde63fdd35d1a49bcdb00a01d3bde";